(function () {
  const TGTP_TENANTS = window.__tgtpTenantData;

  // テナント解決:
  //   Liquidで解決されたハンドル（リソースのmetafield由来、未設定時は'top'）を常に使用。
  //   URLパラメータは使用しない（リソース自身のtenantを真とする）。
  const liquidTenant = window.__tgtpLiquidTenantHandle || '';
  let tenant = liquidTenant;

  if (tenant && !TGTP_TENANTS[tenant]) {
    tenant = '';
  }

  // 最終フォールバック: top
  if (!tenant && TGTP_TENANTS['top']) {
    tenant = 'top';
  }

  // CSS 変数を適用
  // index テンプレートかつ home 設定がある場合は home の値のみ使用（テナント設定で穴埋めしない）
  if (tenant) {
    const cfg = TGTP_TENANTS[tenant];
    const isIndex = window.__tgtpLiquidTenantSource === 'index';
    const colors = (isIndex && cfg.home) ? cfg.home : cfg;
    const root = document.documentElement.style;
    if (colors.header)             root.setProperty('--tgtp-color-header', colors.header);
    if (colors.on_header)          root.setProperty('--tgtp-color-on-header', colors.on_header);
    if (colors.primary)            root.setProperty('--tgtp-color-primary', colors.primary);
    if (colors.surface)            root.setProperty('--tgtp-color-surface', colors.surface);
    if (colors.on_surface)         root.setProperty('--tgtp-color-on-surface', colors.on_surface);
    if (colors.card_surface)       root.setProperty('--tgtp-color-card-surface', colors.card_surface);
    if (colors.on_primary)         root.setProperty('--tgtp-color-on-primary', colors.on_primary);
    if (colors.outline)            root.setProperty('--tgtp-color-outline', colors.outline);
    if (colors.secondary)          root.setProperty('--tgtp-color-secondary', colors.secondary);
    if (colors.container)          root.setProperty('--tgtp-color-container', colors.container);
    if (colors.on_container)       root.setProperty('--tgtp-color-on-container', colors.on_container);
    if (colors.surface_scrim)      root.setProperty('--tgtp-color-surface-scrim', colors.surface_scrim);
    if (colors.on_surface_scrim)   root.setProperty('--tgtp-color-on-surface-scrim', colors.on_surface_scrim);
    if (colors.footer)             root.setProperty('--tgtp-color-footer', colors.footer);
    if (colors.on_footer)          root.setProperty('--tgtp-color-on-footer', colors.on_footer);

    if (colors.bg_image) {
      root.setProperty('--tgtp-bg-image', `url(${colors.bg_image})`);
    }
    if (colors.bg_image_mobile) {
      root.setProperty('--tgtp-bg-image-mobile', `url(${colors.bg_image_mobile})`);
    }
  }

  window.__tgtpTenant = tenant;
  window.__tgtpTenants = TGTP_TENANTS;

  // 商品リンクにテナントクエリパラメータを付与
  // テナントが確定している場合、/products/ へのリンクに ?tenant= を付与して遷移先でも判定できるようにする
  if (tenant && tenant !== 'top') {
    function appendTenantToProductLinks(root) {
      var links = (root || document).querySelectorAll('a[href*="/products/"]');
      links.forEach(function(a) {
        try {
          var url = new URL(a.href, window.location.origin);
          if (url.pathname.startsWith('/products/') && !url.searchParams.has('tenant')) {
            url.searchParams.set('tenant', tenant);
            a.href = url.toString();
          }
        } catch (e) {}
      });
    }

    // 初回実行
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { appendTenantToProductLinks(); });
    } else {
      appendTenantToProductLinks();
    }

    // 動的に追加されるリンクにも対応 (MutationObserver)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            appendTenantToProductLinks(node);
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    window.__tgtpAppendTenantToProductLinks = appendTenantToProductLinks;
  }
})();
